export const TemplateTags = [
    'Hook Animation',
    'Audio Only',
    'Background Video',
    'Wide Shot',
    'Close-Up',
    'Medium Shot',
    'Clip as Background',
    'Plain',
    'Light Graphics',
    'Medium Graphics',
    'Heavy Graphics',
    'Frame'
];
